import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";

const Confirmation = ({ isOpen, toggle, onConfirm }) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader toggle={toggle}>  Request submitted  <img src="https://i.gifer.com/7efs.gif" alt="" width={70}  /> </ModalHeader>
      <ModalBody>
        
         Request submitted for adding a camera. You can set the ROI in the 'Edit Camera' option after 15 minutes.
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={onConfirm}>OK</Button> 
      </ModalFooter>
    </Modal>
  );
};

export default Confirmation;
